import { useParams } from 'react-router-dom';

import { ProductType } from '../graphql';
import { ProductPathSchema } from '../utils/product.utils';

export const useSelectedProductOptional = (): ProductType | null => {
  const { product } = useParams();
  if (!product) {
    return null;
  }
  const result = ProductPathSchema.safeParse(product);

  if (!result.success) {
    return null;
  }

  return result.data;
};
